import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-c",
  "use": "icon-c-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-c\"><path fill=\"#333333\" d=\"M566.272 35.84c224.256 0 339.968 125.952 339.968 125.952L826.368 286.72s-105.472-97.28-251.904-97.28c-194.56 0-309.248 145.408-309.248 316.416 0 175.104 117.76 329.728 310.272 329.728 159.744 0 267.264-116.736 267.264-116.736L930.816 839.68S803.84 989.184 568.32 989.184C286.72 989.184 92.16 780.288 92.16 508.928 93.184 240.64 294.912 35.84 566.272 35.84z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol